/** @format */

import Plugin from "src/plugin-system/plugin.class";

export default class IwConfiguratorPlugin extends Plugin {
    init() {
        const groupElements = document.querySelectorAll(
            ".product-detail-configurator-group-wrapper"
        );
        const drawerElements = document.querySelectorAll(
            ".product-detail-configurator-options-drawer"
        );

        const closeDrawerElements = document.querySelectorAll(
            ".product-detail-configurator-options-close"
        );

        function hideOnClickOutside(element) {
            const drawerContent = element.getElementsByClassName(
                "product-detail-configurator-options-content"
            )[0];

            const closeElement = element.getElementsByClassName(
                "product-detail-configurator-options-close"
            )[0];

            const outsideClickListener = (event) => {
                if (!drawerContent.contains(event.target) && element.classList.contains("open")) {
                    element.classList.remove("open");
                    drawerContent.classList.remove("open");
                    document.querySelector("body").classList.remove("modal-open");

                    removeClickListener();
                }
            };

            const removeClickListener = () => {
                document.removeEventListener("click", outsideClickListener);
            };

            if (!element.classList.contains("open")) {
                element.classList.add("open");
                drawerContent.classList.add("open");
                document.querySelector("body").classList.add("modal-open");

                setTimeout(() => document.addEventListener("click", outsideClickListener), 500);
            }

            closeElement.addEventListener("click", () => {
                element.classList.remove("open");
                drawerContent.classList.remove("open");

                document.querySelector("body").classList.remove("modal-open");

                removeClickListener();
            });
        }

        setTimeout(
            () =>
                drawerElements.forEach((drawerElement) => {
                    drawerElement.classList.remove("no-transition-on-load");
                }),
            500
        );

        groupElements.forEach((groupElement) => {
            groupElement.addEventListener("click", (event) => {
                const target = event.currentTarget;
                let groupId = target.getAttribute("data-group-id");

                if (!groupId) {
                    groupId = target.parentElement.getAttribute("data-group-id");
                }

                const elem = document.getElementById(groupId);

                hideOnClickOutside(elem);
            });
        });
    }
}
